import { css } from '@emotion/css';
import { Typography, theme } from 'antd';
import type React from 'react';
import type { LocalizationFieldType } from '../../../graphql/generated/graphql.ts';
import { germanDecimal } from '../../../utils/localizationValue.ts';

interface RecordedFieldValue {
  label: string;
  unit?: string | null;
  value: string;
  inputType: LocalizationFieldType;
}

/**
 * The Lokalisation's extra fields as they were recorded when the sample was taken. Read-only on
 * purpose: a Nachforderung reuses the existing Etikett, so these identify the sample rather than
 * being entered again.
 */
export const RecordedFieldValues: React.FC<{ values: readonly RecordedFieldValue[] }> = ({ values }) => {
  const { token } = theme.useToken();

  if (!values.length) {
    return null;
  }

  const style = css`
    display: block;
    margin: ${token.marginXXS}px 0 ${token.marginXS}px ${token.marginLG}px;
    font-size: ${token.fontSizeSM}px;
  `;

  return (
    <Typography.Text type="secondary" className={style}>
      {values.map(it => `${it.label}: ${germanDecimal(it.value, it.inputType)}${it.unit ? ` ${it.unit}` : ''}`).join(', ')}
    </Typography.Text>
  );
};
